import { render, staticRenderFns } from "./MailServer.vue?vue&type=template&id=1ad5d634"
import script from "./MailServer.vue?vue&type=script&lang=js"
export * from "./MailServer.vue?vue&type=script&lang=js"
import style0 from "./MailServer.vue?vue&type=style&index=0&id=1ad5d634&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports